<template>
  <div class="animated fadeIn pt2 pb4">
    <!-- desktop view -->
    <div class="flex flex-column gibson mt2 pl4 mb2" v-if="!showMobile">
      <div class="col-6">
        <div class="col-12 py3">
          <p class="h4 darkblue gibson semi-bold mb2">
            Ofte stillede spørgsmål
          </p>
          <div class="col-12 px0 py1 lightgrey-background flex justify-start items-center">
            <span class="h5 line-height-1 m0 p0 mx2"><i class="el-icon-search"></i></span>
            <span class="flex-auto">
              <input v-model="searchQuery" placeholder="Søg efter" type="text" class="lightgrey-background col-11 h5 regular gibson darkblue border-none not-rounded line-height-1 m0 p0" @keyup="checkSearch()">
            </span>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="clearfix" v-if="questionLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div v-else>
          <div v-for="item in resultQuery" :key="item.ID">
            <button v-b-toggle="item.ID" class="faq-btn col-12 py2 gibson white-button not-rounded flex justify-between items-start line-height-1">
              <span class="h5 gibson regular primarycolor mb0 mr2 inline-block left-align line-height-3">{{item.PROPERTY_QUESTION_VALUE}}</span>
              <span class="when-closed">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="20" height="20" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </span>
              <span class="flex-none when-opened">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="20" height="20" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                </span>
              </span>
            </button>
            <b-collapse :id="item.ID" class="col-12 my2">
              <div class="h5 regular gibson darkblue line-height-4 flex flex-column" v-html="item.PROPERTY_ANSWER_VALUE.TEXT"></div>
            </b-collapse>
          </div>
          <div class="p2" v-if="noDataFound"><p class="h5 mediumgrey">Ingen data fundet.</p></div>
        </div>
      </div>
    </div>
    <!-- mobile view -->
    <div class="flex flex-wrap justify-start gibson mt2" v-if="showMobile">
      <div class="col-12 p3">
        <p class="h4 darkblue gibson semi-bold mb2">
          Ofte stillede spørgsmål
        </p>
        <div class="col-12 px0 py1 lightgrey-background flex justify-start items-center">
          <span class="h5 line-height-1 m0 p0 mx2"><i class="el-icon-search"></i></span>
          <span class="flex-auto">
            <input v-model="searchQuery" placeholder="Søg efter" type="text" class="lightgrey-background col-11 h4 regular gibson darkblue border-none not-rounded line-height-1 m0 p0" @keyup="checkSearch()">
          </span>
        </div>

      </div>
      <div class="col-12 p3">
        <div class="clearfix" v-if="questionLoading">
          <div class="col-12">
            <div class="loader"></div>
          </div>
        </div>
        <div v-else>
          <div v-for="item in resultQuery" :key="item.ID">
            <button v-b-toggle="item.ID" class="col-12 px0 py2 gibson white-button not-rounded flex justify-between items-start line-height-1">
              <span class="h4 gibson regular primarycolor mb0 mr2 inline-block left-align line-height-3">{{item.PROPERTY_QUESTION_VALUE}}</span>
              <span class="when-closed">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="20" height="20" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </span>
              <span class="flex-none when-opened">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="20" height="20" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                </span>
              </span>
            </button>
            <b-collapse :id="item.ID" class="my2">
              <div class="h5 regular gibson darkblue line-height-4 flex flex-column" v-html="item.PROPERTY_ANSWER_VALUE.TEXT"></div>
            </b-collapse>
          </div>
          <div class="py2" v-if="noDataFound"><p class="h5 mediumgrey">Ingen data fundet.</p></div>
        </div>
      </div>
      <div class="py4"></div>
      <div style="height:100px;"></div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
export default {
  name: 'faq',
  components: {},
  data () {
    return {
      questionLoading: true,
      searchQuery: null,
      questions: [],
      noDataFound: false
    }
  },
  methods: {
    sendSMS () {
      let closeFn = function () {
        this.$router.push('/medlemsfordele')
      }
      let obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<div class="flex flex-column justify-center items-center pt3"><img src="/static/svg/blue-checkmark.svg" width="50" height="50"><p class="h3 mt3 regular gibson darkblue line-height-2">Tak!</p></div>',
        type: 'success',
        customCloseBtnClass: 'muted-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk',
        onClose: closeFn
      }
      this.$refs.simplert.openSimplert(obj)
    },
    checkSearch () {
      var faq = document.querySelectorAll('.faq-btn')
      if (faq.length > 0) {
        this.noDataFound = false
      } else {
        this.noDataFound = true
      }
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  computed: {
    resultQuery () {
      if (this.searchQuery) {
        return this.questions.filter((item) => {
          return this.searchQuery.toLowerCase().split(' ').every(v => item.PROPERTY_QUESTION_VALUE.toLowerCase().includes(v))
        })
      } else {
        return this.questions
      }
    }
  },
  mounted () {
    this.show = true
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    var data = {operation: 'getQuestionsAndAnswers', salesPerson: this.salesPerson, type: 'GET', url: 'bitrix/getMembers'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          this.show = false
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.questions = res
          this.questionLoading = false
        },
        response => {
          alert('error')
        }
      )
  }
}
</script>
<style>
b {
  font-weight:600;
}
input[type="text"]:focus {
  outline:none;
}
.loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// faq.vue?87ffd73a